import { Box, Typography } from '@mui/material';
import ReactLoading from 'react-loading';

interface Props {
  loading: boolean;
  label: string;
  light?: boolean;
  contrast?: boolean;
  onClick: (event?: React.MouseEvent) => void;
}

const SendButton: React.FC<Props> = ({ loading, label, light, contrast, onClick }) => {
  const getBackgroundColor = () => {
    if (contrast) return '#DCEAE433';
    if (light) return '#F2F4F7';
    return '#C1FE4033';
  };

  const getLoadingColor = () => {
    if (contrast || light) return '#000000';
    return '#C1FE4033';
  };

  const getArrowSrc = () => {
    if (contrast || light) return '/assets/background/arrow.svg';
    return '/assets/uploadFile/arrow.svg';
  };

  const getTextColor = () => {
    if (contrast || light) return '#000000';
    return '#C1FE40';
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
      {loading ? (
        <Box>
          <ReactLoading
            type={'bubbles'}
            color={getLoadingColor()}
            height={50}
            width={50}
          />
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            p: '15px',
            borderRadius: '15px',
            backgroundColor: getBackgroundColor(),
            cursor: 'pointer',
          }}
          onClick={onClick}
        >
          <img
            alt="arrow"
            src={getArrowSrc()}
            style={{
              pointerEvents: 'none',
              userSelect: 'none',
            }}
          />
        </Box>
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          maxWidth: '60px',
          textAlign: 'left',
        }}
      >
        <Typography
          fontWeight={'700'}
          fontSize={'14px'}
          fontFamily={'AlmoniDL'}
          color={getTextColor()}
        >
          {label}
        </Typography>
      </Box>
    </Box>
  );
};

export default SendButton;
